import React from 'react'

const Mail = props => (
  <svg width={24} height={16} {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M1.999 14L2 2.964l9.411 6.845c.041.029.088.044.132.067.035.018.067.039.104.053a.985.985 0 00.705 0c.039-.014.071-.035.108-.055.042-.022.088-.036.128-.065l9.413-6.845V14H1.999zM12 7.764L4.075 2h15.85L12 7.764zM24 15V1c0-.02-.01-.036-.011-.055a1.001 1.001 0 00-.067-.331A1.001 1.001 0 0023 0H1a.99.99 0 00-.677.272C.314.281.302.284.293.293.28.305.275.323.265.336a.984.984 0 00-.188.28C.027.737 0 .868 0 1v14c0 .132.027.263.077.384.045.106.112.198.188.282.011.012.015.029.028.041.009.009.021.012.03.021A.99.99 0 001 16h22a1.001 1.001 0 00.922-.614c.044-.104.06-.217.067-.331.001-.019.011-.035.011-.055z"
    />
  </svg>
)

export default Mail
